import React from 'react'

const DarkSection = ({children, color}) => {
  return (
    <div style={{background: color ? color : '#254334'}}>
      {children}
    </div>
  )
}

export { DarkSection }
